// The web bundle's own release version vs. the server's: after a server update the browser (or
// the Android app's WebView) may still run the old bundle until the service worker has swapped
// it; the app then offers a refresh instead of silently showing the old pages.

/** The version this bundle was built with ("dev" locally). */
export function buildVersion(): string {
  return typeof __APP_VERSION__ === 'string' && __APP_VERSION__ ? __APP_VERSION__ : 'dev';
}

/**
 * True when the server runs another release than this bundle: both versions known, neither a
 * local "dev" build (a dev bundle talks to any server, and a dev server ships whatever was built).
 */
export function isOutdated(build: string, server: string | null | undefined): boolean {
  if (!server || build === 'dev' || server === 'dev') return false;
  return build !== server;
}

/** Asks the service worker for the new bundle and loads the page again. */
export async function refreshApp(): Promise<void> {
  try {
    const registration = await navigator.serviceWorker?.getRegistration();
    await registration?.update();
  } catch {
    // Without a service worker a plain reload fetches the new index.html (served with no-cache).
  }
  window.location.reload();
}
